module.exports = require('./withErrorHandler')



// WEBPACK FOOTER //
// ./src/index.js